import React, { forwardRef } from 'react';
import '../../InputEmail.css';
import InputBase from '../../../InputBase';
import { IInputProps } from '../../../InputBase/InputBase';
import InputBaseOrangeAsteriskVariant from '../../../InputBase/Variants/OrangeAsteriskVariant/InputBaseOrangeAsteriskVariant';

const InputEmailOrangeAsteriskVariant = forwardRef(
	(
		{
			className = '',
			value = '',
			setValue = () => { },
			label,
			...rest
		}: IInputProps,
		ref: any,
	) => {
		// it's looking for the last character to not allowing to enter 2 special characters together
		const sameCharacterTwice = (stringToCompare) => {
			if (
				stringToCompare
					.charAt(stringToCompare.length - 1)
					.match(/[@.!#$%&'\*\+/=?^`{|-]/)
			) {
				return (
					stringToCompare.charAt(stringToCompare.length - 1) ===
					stringToCompare.charAt(stringToCompare.length - 2)
				);
			}
			return false;
		};

		// validates that no bad chars are used. **maybe there should be more characteres allowed?**
		// the second replace it doesn't allow to type a wrong first character for the email. (When onblur, regex used won't validate those characters. That's why it doesn't allow to enter them as the first character. ).

		const formatEmail = (email) => {
			const charAllowedEmail = email
				.replace(/[^0-9A-Za-z@._!#$%&'*+/=?^`{|-]~/g, '')
				.replace(/^[-_@.!#$%&'*+/=?^`{|]~/, '');

			const createFormat = sameCharacterTwice(charAllowedEmail)
				? charAllowedEmail.substring(0, charAllowedEmail.length - 1)
				: charAllowedEmail;

			return createFormat;
		};

		const isEmailValid = (email) => {
			return !!email.match(/^([\w.+-]+)@([\w.+-]+)\.([\w.+-]+)$/g)
		};

		return (
			<InputBaseOrangeAsteriskVariant
				type='email'
				label={label}
				className={`InputEmail ${className}`}
				id='emailAddress'
				formatValue={formatEmail}
				isValid={isEmailValid}
				value={value}
				ref={ref}
				setValue={(val) => {
					setValue(formatEmail(val));
				}}
				{...rest}
			/>
		);
	},
);
InputEmailOrangeAsteriskVariant.displayName = 'InputEmail';

export default InputEmailOrangeAsteriskVariant;
